module.exports = __webpack_public_path__ + "static/img/dgf3.6bdc14c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/dgf3.jpg
// module id = wB+l
// module chunks = 0